import * as ExpressCheckoutActionTypes from '../actionTypes/ExpressCheckoutActionTypes';

export const expressCheckoutDisplayed = (
    displayExpressCheckout,
    addressExpressCheckout,
    paymentExpressCheckout
) => ({
    type: ExpressCheckoutActionTypes.DISPLAY_EXPRESS_CHECKOUT,
    payload: { displayExpressCheckout, addressExpressCheckout, paymentExpressCheckout },
});

export const toggleExpressCheckout = (addressExpressCheckout, paymentExpressCheckout) => ({
    type: ExpressCheckoutActionTypes.TOGGLE_EXPRESS_CHECKOUT,
    payload: { addressExpressCheckout, paymentExpressCheckout },
});

export const updateExpressCheckoutPayment = () => ({
    type: ExpressCheckoutActionTypes.EXPRESS_CHECKOUT_PAYMENT,
});

export const updateExpressCheckoutAddress = () => ({
    type: ExpressCheckoutActionTypes.EXPRESS_CHECKOUT_ADDRESS,
});

export default {
    toggleExpressCheckout,
    updateExpressCheckoutPayment,
    updateExpressCheckoutAddress,
    expressCheckoutDisplayed,
};
